import Axios from 'axios'
import router from '../router'
import moment from 'moment'

export default {
  state: {
    user: JSON.parse(localStorage.getItem('currentUser')) || null,
    token: localStorage.getItem('token') || ''
  },
  getters: {
    user(state) {
      return state.user;
    },
    token(state) {
      return state.token;
    },
    isLoggedIn(state) { return state.user !== null && state.user !== undefined; },
  },
  actions: {
    signUserInGoogle({ commit }, payload) {
      commit('setLoading')
      commit('clearError')
      Axios.post(process.env.VUE_APP_API_URL_GOOGLE_USER,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache': 'no-cache'
          },
          credentials: '*'
        }).then(res => { console.log(res) })
      // console.log(process.env.VUE_APP_GOOGLE_ID)
      // Vue.gAuth.signIn().then(async googleUser => {
      //   console.log('googleUser', googleUser)
      //   await Axios.post(process.env.VUE_APP_API_URL_GOOGLE_USER,
      //     {
      //       access_token: googleUser.wc.access_token,
      //       type: payload.type
      //     }, {
      //     headers: {
      //       'Content-Type': 'application/json'
      //     },
      //   }).then(res => {
      //     if (res.data.success) {
      //       commit('setLoading');
      //       commit('setUser', res.data.data);
      //       commit('setToken', res.data.token);
      //       localStorage.setItem('currentUser', JSON.stringify(res.data.data));
      //       localStorage.setItem('token', res.data.token);
      //       Axios.defaults.headers.common['Authorization'] = res.data.token;
      //       if (res.data.data.isNew)
      //         commit('setSnackAlert', {
      //           status: true,
      //           success: true,
      //           error: false,
      //           message: 'Bienvenue <strong>' + res.data.data.name + '</strong> dans Sportopia.'
      //         })
      //       router.push('dashboard/index');
      //     } else
      //       throw new Error(res.data);
      //   }).catch(error => {//catch error
      //     console.log('error', error)
      //     commit('setLoading');
      //     commit('clearError');
      //     localStorage.removeItem('token');
      //     commit('setError', error);
      //   });
      // }, function (error) {
      //   console.log('here', error)
      //   commit('setLoading');
      //   commit('clearError');
      //   commit('setError', error);
      // });
    },
    async signUserInFacebookPassport({ commit }, payload) {
      commit('setLoading')
      commit('clearError')
      await Axios.post(process.env.VUE_APP_API_URL_FACEBOOK_USER,
        {
          access_token: payload.accessToken,
          type: payload.type
        },
        {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(res => {
          commit('setLoading');
          commit('setUser', res.data.data);
          commit('setToken', res.data.token);
          localStorage.setItem('currentUser', JSON.stringify(res.data.data));
          localStorage.setItem('token', res.data.token);
          Axios.defaults.headers.common['Authorization'] = res.data.token;
          commit('clearSnackAlert')
          if (res.data.data.isNew)
            commit('setSnackAlert', {
              status: true,
              success: true,
              error: false,
              message: 'Bienvenue <strong>' + res.data.data.name + '</strong> dans Sportopia.'
            })
          router.push('dashboard/index');
        }).catch(error => {// catch error
          commit('setLoading');
          commit('clearError');
          localStorage.removeItem('token');
          commit('setError', error);
        })
    },
    async signUserInEmail({ commit }, payload) {
      commit('setLoading');
      commit('clearError');
      return await Axios.post(process.env.VUE_APP_API_URL_CREATE_USER, payload)
        .then(
          res => {
            console.log(res.data)
            commit('setLoading');
            if (res.data.success) {
              commit('clearSnackAlert');
              commit('setSnackAlert', {
                status: true,
                success: true,
                error: false,
                message: 'Bienvenue, vérifié votre boite e-mail'
              });
              // to email verification page
              router.push({ path: '/verify', query: { mail: payload.mail } })
            } else {
              commit('clearError')
              commit('setError', res.data.message);
              return res.data.message
            }
          }
        )
        .catch(
          error => {
            console.log('error', error)
            commit('clearError')
            commit('setError', error);
          }
        );
    },
    async loginUserEmail({ commit }, payload) {
      commit('setLoading');
      commit('clearError');
      await Axios.post(process.env.VUE_APP_API_URL_LOGIN_USER,
        { mail: payload.mail, password: payload.password }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(res => {
          if (res.data.success) {
            if (moment().isSame(res.data.data.firstLogin, 'day'))
              commit('setFirstLoginDialog', true)
            commit('setLoading');
            commit('setUser', res.data.data);
            commit('setToken', res.data.token);
            localStorage.setItem('currentUser', JSON.stringify(res.data.data));
            localStorage.setItem('token', res.data.token);
            Axios.defaults.headers.common['Authorization'] = res.data.token;
            commit('setSnackAlert', {
              status: true,
              success: true,
              error: false,
              message: '<strong>Bienvenue</strong> vous êtes connecté.'
            })
            router.push('/dashboard/index')
          }
          // }
          // else
          //   router.push({ path: '/verify', query: { mail: payload.mail } })
          else
            throw new Error(res.data.message);
        }).catch(error => {
          console.log(error)
          commit('clearError')
          commit('setError', error)
          commit('setLoading');
        })
    },
    socialLoginByToken({ commit }, payload) {
      console.log('payload', payload.mail)
      Axios.post(
        `${process.env.VUE_APP_API_URL_SOCIAL_LOGIN}/${payload.token}`,
        { mail: payload.mail }
      ).then((res) => {
        commit('setUser', res.data.data);
        commit('setToken', res.data.token);
        localStorage.setItem('currentUser', JSON.stringify(res.data.data));
        localStorage.setItem('token', res.data.token);
        Axios.defaults.headers.common['Authorization'] = res.data.token;
        commit('setSnackAlert', {
          status: true,
          success: true,
          error: false,
          message: '<strong>Bienvenue</strong> vous êtes connecté.'
        })
        router.push('/dashboard/index')
      });
    },
    logout({ commit }) {
      localStorage.removeItem('currentUser')
      localStorage.removeItem('token')
      delete Axios.defaults.headers.common['Authorization']
      commit('setUser', null)
      commit('setToken', null)
      commit('clearSnackAlert')
      router.push('/')
    },
    async verifyEmail({ commit }, payload) {
      commit('setLoading');
      commit('clearError');
      await Axios.get(process.env.VUE_APP_API_URL_VERIFY_EMAIL + '?mail='
        + payload.mail + '&id=' + payload.id)
        .then(res => {
          commit('setLoading');
          commit('setSnackAlert', {
            status: true,
            success: true,
            error: false,
            message: '<strong>Bravo</strong> Votre Email a été vérifié.'
          })
          router.push('/login')
        }).catch(error => {
          commit('clearError')
          commit('setError', error)
          commit('setLoading');
        })
    },
    async resendEmail({ commit }, payload) {
      commit('setLoading');
      commit('clearError');
      await Axios.get(process.env.VUE_APP_API_URL_RESEND_EMAIL + '/' + payload.mail)
        .then(res => {
          commit('setLoading');
        }).catch(error => {
          commit('clearError')
          commit('setError', error)
          commit('setLoading');
        })
    },
    async requestResetPassword({ commit }, payload) {
      commit('setLoading');
      commit('clearError');
      await Axios.get(process.env.VUE_APP_API_URL_RESET_PASSWORD_REQUEST + '/' + payload)
        .then(res => {
          commit('setLoading');
          commit('setSnackAlert', {
            status: true,
            success: true,
            error: false,
            message: 'consulter votre voite email! <i class="mdi mdi-email"></i>'
          })
        }).catch(error => {
          commit('clearError')
          commit('setError', error)
          commit('setLoading');
        })
    },
    async resetPassword({ commit }, payload) {
      commit('setLoading');
      commit('clearError');
      await Axios.put(process.env.VUE_APP_API_URL_RESET_PASSWORD,
        payload)
        .then(res => {
          commit('setLoading');
          commit('setSnackAlert', {
            status: true,
            success: true,
            error: false,
            message: '<strong>Félicitations</strong> Votre mot de passe a été mise à jours.'
          })
          router.push('/login')
        }).catch(error => {
          commit('clearError')
          commit('setError', error)
          commit('setLoading');
        })
    },
    async updatePassword({ commit, getters }, payload) {
      commit('setLoading');
      commit('clearError');

      await Axios.put(`${process.env.VUE_APP_API_URL_UPDATE_PASSWORD}/${getters.user._id}`,
        payload)
        .then(res => {
          commit('setLoading');
          if (res.data.success) {
            commit('setSnackAlert', {
              status: true,
              success: true,
              error: false,
              message: '<strong>Félicitations</strong> Votre mot de passe a été mise à jours.'
            })
          }
        }).catch(error => {
          commit('clearError')
          commit('setError', error)
          commit('setLoading');
        })
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setToken(state, payload) {
      state.token = payload
    },
    addExperience(state, payload) {
      state.user.coach.experience = payload
    },
    addDiploma(state, payload) {
      state.user[state.user.type].diploma = payload
    },
    addEvents(state, payload) {
      state.user.gym.events = payload
    }
  }
}
